import React from 'react'

const Contact = () => {
  return (
    <div name='contact' className='w-full h-screen bg-[#0a192f] flex justify-center items-center p-4'>
      <form 
        action='https://getform.io/f/039972c3-7ed6-48a1-b1e6-30e74c2e185b'
        method='POST' 
        className='flex flex-col max-w-[1000px] w-full'
      >
        <div className='pb-8'>
          <p className='text-4xl font-bold inline border-b-4 border-blue-600 text-gray-300'>Contact Me</p>
          <p className='text-gray-300 py-4'>Got anything to communicate with me? </p>
        </div>
        <input className='p-2 bg-[#ccd6f6]' type='text' placeholder='Name' name='name' />
        <input className='my-4 p-2 bg-[#ccd6f6]' type='text' placeholder='Email' name='email' />
        <textarea className='bg-[#ccd6f6] p-2' name='message' rows='7' placeholder='Message'></textarea>
        <button className='text-white border-2 hover:bg-blue-600 hover:border-blue-600 duration-500 px-4 py-3 my-8 mx-auto flex items-center'>Connect With Me</button>
      </form>
      
    </div>
  )
}

export default Contact
